import React, { useState } from "react";
import AddQuestion from "./AddQuestion";
import ListQuestion from "./ListQuestion";

const Question = ({ examTitle }) => {
  const [isActive, setActive] = useState("false");
  const handleToggle = () => {
    setActive(!isActive);
  };
  return (
    <>
      <main className=" container flex-1 overflow-x-hidden overflow-y-auto">
        <div className="container mx-auto px-6 py-3">
          <h3 className="text-gray-700 text-3xl font-bold">
            Manage Questions for {examTitle}
          </h3>
          <AddQuestion />
          <hr />
          <div className="mt-3">
            <ListQuestion />
          </div>
        </div>
      </main>
    </>
  );
};

export default Question;
